import React, { useState } from "react";
import { Box, Typography, Link } from "@mui/material";
import { styled, keyframes } from "@mui/system";
import PrivacyPolicyComponent from "../PrivacyPolicy/PrivacyPolicyComponent";

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(100px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const FooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(6),
  animation: `${slideUp} 1s ease-in-out`,
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(3),
  },
}));

const FooterComponent = () => {
  const [isPrivacyOpen, setPrivacyOpen] = useState(false);

  const handlePrivacyOpen = () => setPrivacyOpen(true);
  const handlePrivacyClose = () => setPrivacyOpen(false);

  return (
    <FooterContainer>
      <Typography variant="body1" align="center">
        © {new Date().getFullYear()} Guadalupe Rosas. Todos los derechos reservados.
      </Typography>
      <Typography variant="body2" align="center">
        <Link href="#" onClick={handlePrivacyOpen}>
          Política de Privacidad
        </Link>
      </Typography>
      {isPrivacyOpen && (
        <PrivacyPolicyComponent open={isPrivacyOpen} onClose={handlePrivacyClose} />
      )}
    </FooterContainer>
  );
};

export default FooterComponent;
